export default "/_next/static/images/header-bg-20ef41893ec2f7af9170bc4a48eef21f.png";